import IconButton from "@material-ui/core/IconButton";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

import clsx from "clsx";
import React from "react";
import { connect } from "react-redux";
import { COLORS } from "../../constants/Colors";
import axios from "axios";
import { iStaffBaseURL } from "src/constants/Urls";
import { dispatchBulkUpdatePendingPlacements } from "./helperFunctions";
import { notify } from "../../functions/function";

const EnhancedTableToolbar = ({
  numSelected,
  title,
  selectedTimesheets,
  setSelectedTimesheets,
  timesheetTable,
  pendingPlacements,
  userToken,
  dispatch,
}) => {
  const useToolbarStyles = makeStyles((theme) => ({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(1),
    },

    highlight:
      theme.palette.type === "light"
        ? {
            color: COLORS.iStaffGreen,
            backgroundColor: lighten(COLORS.WHITE, 1),
          }
        : {
            color: COLORS.iStaffGreenDarker,
            backgroundColor: lighten(COLORS.iStaffGreenDarker, 1),
          },
    title: {
      flex: "1 1 100%",
    },
  }));

  const classes = useToolbarStyles();

  const handleiStaffApproveAllSelected = () => {
    var bulkUpdateArray = [];

    for (let i = 0; i < numSelected; i++) {
      var currentRow = pendingPlacements.filter(
        (x) => x.id === selectedTimesheets[i]
      )[0];
      if (currentRow) {
        var timesheetObjectToAdd = {
          id: parseInt(currentRow.timesheet.id),
          placement: parseInt(currentRow.id),
          clock_in_time: currentRow.timesheet.clock_in_time,
          clock_in_latitude: parseFloat(currentRow.timesheet.clock_in_latitude),
          clock_in_longitude: parseFloat(
            currentRow.timesheet.clock_in_longitude
          ),
          approval_status: "Approved",
          is_complete:
            currentRow.timesheet.client_approval_status !== "Pending"
              ? true
              : false,
        };
        bulkUpdateArray.push(timesheetObjectToAdd);
      }
    }

    axios
      .put(iStaffBaseURL + `/handler/placements/timesheets/`, bulkUpdateArray, {
        headers: { Authorization: `Token ${userToken}` },
      })
      .then((response) => {
        var status = "Approved";
        var isClient = false;
        dispatchBulkUpdatePendingPlacements(
          dispatch,
          pendingPlacements,
          numSelected,
          selectedTimesheets,
          status,
          isClient
        );

        setSelectedTimesheets([]);
      })
      .catch((error) => {
        console.log(error);
        notify("Failed", "Error Occured. Please Try Again", "danger");
      });
  };

  const handleiStaffDeclineAllSelected = () => {
    var bulkUpdateArray = [];

    for (let i = 0; i < numSelected; i++) {
      var currentRow = pendingPlacements.filter(
        (x) => x.id === selectedTimesheets[i]
      )[0];
      if (currentRow) {
        var timesheetObjectToAdd = {
          id: parseInt(currentRow.timesheet.id),
          placement: parseInt(currentRow.id),
          clock_in_time: currentRow.timesheet.clock_in_time,
          clock_in_latitude: parseFloat(currentRow.timesheet.clock_in_latitude),
          clock_in_longitude: parseFloat(
            currentRow.timesheet.clock_in_longitude
          ),
          approval_status: "Declined",
          is_complete:
            currentRow.timesheet.client_approval_status !== "Pending"
              ? true
              : false,
        };
        bulkUpdateArray.push(timesheetObjectToAdd);
      }
    }
    axios
      .put(iStaffBaseURL + `/handler/placements/timesheets/`, bulkUpdateArray, {
        headers: { Authorization: `Token ${userToken}` },
      })
      .then((response) => {
        var status = "Declined";
        var isClient = false;
        dispatchBulkUpdatePendingPlacements(
          dispatch,
          pendingPlacements,
          numSelected,
          selectedTimesheets,
          status,
          isClient
        );
        setSelectedTimesheets([]);
      })
      .catch((error) => {
        console.log(error);
        notify("Failed", "Error Occured. Please Try Again", "danger");
      });
  };

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <>
          <Typography
            className={classes.title}
            color="inherit"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected {"\n"}
          </Typography>
        </>
      ) : (
        <Typography
          className={classes.title}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {title}
        </Typography>
      )}
      <Tooltip title="Filter list">
        {numSelected > 0 && timesheetTable ? (
          <>
            <IconButton>
              <button
                type="button"
                class="btn btn-outline-primary"
                onClick={() => {
                  handleiStaffApproveAllSelected();
                }}
              >
                iStaff Approve All
              </button>
            </IconButton>

            <IconButton>
              <button
                type="button"
                class="btn btn-outline-danger"
                onClick={() => {
                  handleiStaffDeclineAllSelected();
                }}
              >
                iStaff Decline All
              </button>
            </IconButton>
          </>
        ) : (
          <IconButton aria-label="filter list"></IconButton>
        )}
      </Tooltip>
    </Toolbar>
  );
};

function mapStateToProps(state) {
  return {
    pendingPlacements: state.userPlacementsReducer.pendingPlacements,
    userToken: state.userTokenReducer.userToken,
  };
}

export default connect(mapStateToProps)(EnhancedTableToolbar);
